<template>
  <b-modal
    hide-footer
    ref="modal-view"
    size="xl">

    <template #modal-header="">
      <!-- Emulate built in modal header close button action -->
      <h5>{{ modelId > 0 ? 'Edición de regla de canal' : 'Nueva regla de canal' }}</h5>
      <h5><b-badge variant="info">{{ ruleName.toUpperCase() }}</b-badge></h5>
    </template>

    <b-overlay :show="loading" no-wrap></b-overlay>

    <div class="mx-3 my-2">
      <h4 class="text-muted" v-if="item != null">[{{ item.id }}] {{ item.name }}</h4>
      <b-form @submit="submit">

        <!-- Gral settings -->
        <b-form-row>
          <b-form-group
            class="col-lg-4"
            label="Nombre">
            <b-form-input
              type="text"
              v-model="model.name" 
              required/>
          </b-form-group>

          <b-form-group
            class="col-lg-5"
            label="Canal de venta">
            <multiselect
              :options="salesChannelsOpts"
              v-model="model.salesChannelId"
              :disabled="disabled"
              label="name"
              track-by="id"/>
          </b-form-group>

          <b-form-group
            class="col-lg-3 text-center"
            label="Estado">
            <b-form-radio-group
              v-model="model.status"
              name="status"
              class="mb-1">
              <b-form-radio value="active" checked>Activo</b-form-radio>
              <b-form-radio value="inactive">Inactivo</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group
            class="col-lg-6"
            label="Destino">
            <multiselect
              :options="destinationsOpts"
              v-model="model.zones"
              :disabled="disabled"
              label="name"
              track-by="name"
              @input="resetZonesValues"/>
          </b-form-group>
        </b-form-row>
        <!-- End gral settings -->

        <div class="font-weight-bold pt-1">Configuración de reglas</div>
        <hr/>

        <b-form-row>
          <b-form-group label="Categoria de servicios" class="col-lg-3 col-6">
            <b-form-select 
              reset-button size="sm" 
              v-model="setting.serviceTypeCategoryId" 
              :options="serviceTypeOpts">
            </b-form-select>
          </b-form-group>

          <b-form-group class="col-lg-2 col-6" label="Ticket">
            <b-form-select reset-button size="sm" v-model="setting.type">
              <b-select-option value="">Todos</b-select-option>
              <b-select-option value="roundtrip">Roundtrip</b-select-option>
              <b-select-option value="oneway">Oneway</b-select-option>
            </b-form-select>
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group label="Zona pickup" class="col-lg-4 col-6">
            <multiselect
              :options="zonesOpts"
              v-model="setting.fromZoneId"
              label="name"
              track-by="id"/>
          </b-form-group>

          <b-form-group label="Zona dropoff" class="col-lg-4 col-6">
            <multiselect
              :options="zonesOpts"
              v-model="setting.toZoneId"
              label="name"
              track-by="id"/>
          </b-form-group>

          <b-form-group class="col-lg-4 col-12" label="Aplicar retorno">
            <b-form-checkbox v-model="setting.applyReturn">
              Aplica en orden inverso (Zonas)
            </b-form-checkbox>
          </b-form-group>
        </b-form-row>

        <!-- Buffer time rules -->
        <b-form-row v-if="model.ruleType == 'buffer_time'">
          <b-form-group
            class="col-lg-3"
            label="Vuelos Nacionales">
            <b-form-input 
                type="number" 
                v-model="setting.bufferTimeNational" 
                />
          </b-form-group>

          <b-form-group
            class="col-lg-3"
            label="Vuelos Internacionales">
            <b-form-input 
              type="number" 
              v-model="setting.bufferTimeInternational" 
              />
          </b-form-group>

          <b-form-group
            class="col-lg-3"
            label="Unidad de tiempo">
            <b-form-select 
              v-model="setting.bufferTimeUnit" 
              :options="timeOpts">
            </b-form-select>
          </b-form-group>

          <b-form-group label="."  class="col-lg-3 col-12">
            <b-button variant="outline-primary" @click="addRuleSetting()">Agregar</b-button>
          </b-form-group>

        </b-form-row>
        
        <!-- Cutoff time rules -->
        <b-form-row v-if="model.ruleType == 'cutoff'">
          <b-form-group
            class="col-lg-3"
            label="Tiempo de cutoff">
            <b-form-input 
              type="number" 
              v-model="setting.cutoffTime"
              />
          </b-form-group>

          <b-form-group
            class="col-lg-3"
            label="Unidad de tiempo">
            <b-form-select 
              v-model="setting.cutoffTimeUnit" 
              :options="timeOpts">
            </b-form-select>
          </b-form-group>

          <b-form-group label="."  class="col-lg-3 col-12">
            <b-button variant="outline-primary" @click="addRuleSetting()">Agregar</b-button>
          </b-form-group>
        </b-form-row>

        <!-- Genius Booking values -->
        <b-form-row v-if="model.ruleType == 'genius_booking'">
          <b-form-group
            class="col-lg-3"
            label="Nivel 1">
            <b-form-input 
              type="number"
              max="10"
              v-model="setting.geniusOne"
              placeholder="Porcentaje"
              />
          </b-form-group>

          <b-form-group
            class="col-lg-3"
            label="Nivel 2">
            <b-form-input 
              type="number" 
              max="10"
              v-model="setting.geniusTwo"
              placeholder="Porcentaje"
              />
          </b-form-group>

          <b-form-group
            class="col-lg-3"
            label="Nivel 3">
            <b-form-input 
              type="number"
              max="10"
              v-model="setting.geniusThree"
              placeholder="Porcentaje"
              />
          </b-form-group>

          <b-form-group label="."  class="col-lg-3 col-12">
            <b-button variant="outline-primary" @click="addRuleSetting()">Agregar</b-button>
          </b-form-group>
        </b-form-row>

        <div><small class="text-muted">**Porcentaje minimo de 5 y máximo de 10, se permite valor de 0</small></div>

        <!-- Show list of rules -->
        <b-form-row class="pt-3">
          <b-col class="col-12">
            <b-table 
              striped 
              hover
              bordered
              :items="settings" 
              :fields="getTableColumns" 
              small
              show-empty
              empty-text="No se encontraron registros"
              responsive
              stacked="lg">

              <template v-slot:cell(index)="row">
                {{row.index+1}}
              </template>

              <template v-slot:cell(type)="row">
                {{ getTicketTypeName(row.item.type) }}
              </template>

              <template v-slot:cell(serviceTypeId)="row">
                {{ getServiceTypeName(row.item.serviceTypeCategoryId) }}
              </template>

              <template v-slot:cell(bufferTimeUnit)="row">
                {{ getTimeUnitName(row.item.bufferTimeUnit) }}
              </template>

              <template v-slot:cell(cutoffTimeUnit)="row">
                {{ getTimeUnitName(row.item.cutoffTimeUnit) }}
              </template>

              <template v-slot:cell(applyReturn)="row">
                <div class="text-center">
                  <b-badge variant="success" v-if="row.item.applyReturn == true">
                    Activo
                  </b-badge> 
                </div>
              </template>

              <template v-slot:cell(actions)="row">
                <div class="text-center">
                  <b-button 
                    size="sm" 
                    @click="confirmDelete(row.index)" 
                    variant="outline-danger">
                    <md-icon icon="delete"></md-icon>
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-form-row>

        <b-form-row>
          <div class="col-lg-12 text-right mt-3">
            <b-button variant="primary" type="submit">
              {{ modelId > 0 ? "Actualizar" : "Guardar" }}
            </b-button>
          </div>
        </b-form-row>
      </b-form>
    </div>
  </b-modal>

</template>

<script>

import Multiselect from "vue-multiselect";
import api from "../../../api.js";

const defaultModelInfo = {
  id: -1,
  name: "",
  salesChannelId: null,
  zones: null,
  ruleType: null,
  status: "active",
}

const defaultSetting = {
  id: -1,
  serviceTypeCategoryId: 0,
  type: '',
  fromZoneId: null,
  toZoneId: null,
  applyReturn: false,
  bufferTimeNational: null,
  bufferTimeInternational: null,
  bufferTimeUnit: 'minutes',
  cutoffTime: null,
  cutoffTimeUnit: 'minutes',
  geniusOne: null,
  geniusTwo: null,
  geniusThree: null
}

export default {
  name: "Rules",
  components: { Multiselect },
  props: {
    unableEdit: Boolean,
    item: {
      required: true
    },
    successCallback: {
			type : Function,
			required: false,
			default: () => {}
		}
	},
  data() {
    return {
        loading: false,
        modelId: -1,
        model: { ...defaultModelInfo },
        setting: { ...defaultSetting },
        settings: [],
        destinationsOpts: [],
        salesChannelsOpts: [],
        timeOpts: [
          {value: 'minutes', text: 'Minutos'},
          {value: 'hours',   text: 'Horas'},
          {value: 'days',    text: 'Dias'}
        ]
    }
  },
  methods: {
    loadModel(id, ruleType = null) {
      this.modelId  = id;
      this.model    = { ...defaultModelInfo }
      this.setting  = { ...defaultSetting }
      this.settings = []
      this.model.ruleType = ruleType
      this.$refs["modal-view"].show();
      this.fetchModel()
    },
    fetchModel() {
      if (this.modelId > 0) {
          this.loading = true;
          api(this).get(`sales-channel-rules/${this.modelId}`)
          .then(res => {
              this.$emit('update:unableEdit', this.$hasPermission('salesChannelRules.edit'))
              this.model       = {...res.data }
              this.model.zones = this.model.zones[0]


              if (this.model.salesChannelId != null) {
                let saleChannel = this.salesChannelsOpts.filter(sc => sc.id == this.model.salesChannelId)
                if (saleChannel.length > 0) {
                  this.model.salesChannelId = {id: saleChannel[0].id, name: saleChannel[0].name}
                }
              }

              this.model.settings.forEach((item) => {

                let from = null
                if (item.fromZoneId != null) {
                  let zoneFrom = this.model.zones.zones.filter(zn => zn.id == item.fromZoneId)
                  if (zoneFrom.length > 0) {
                    from = {id: zoneFrom[0].id, name: zoneFrom[0].name}
                  }
                } else {
                  from = {id: 0, name: 'Todas las zonas'}
                }

                let to = null
                if (item.toZoneId != null) {
                  let zoneTo = this.model.zones.zones.filter(zn => zn.id == item.toZoneId)
                  if (zoneTo.length > 0) {
                    to = {id: zoneTo[0].id, name: zoneTo[0].name}
                  }
                } else {
                  to = {id: 0, name: 'Todas las zonas'}
                }

                let setting = {
                  id : item.id,
                  applyReturn : item.applyReturn,
                  type : item.type??'',
                  serviceTypeCategoryId : item.serviceTypeCategoryId??0,
                  fromZoneId : from,
                  toZoneId : to,
                  bufferTimeNational : item.rules.buffer_time.national,
                  bufferTimeInternational : item.rules.buffer_time.international,
                  bufferTimeUnit: item.rules.buffer_time.time_unit,
                  cutoffTime: item.rules.cutoff.cutoff,
                  cutoffTimeUnit: item.rules.cutoff.time_unit
                }

                if (item.rules.genius) {
                  setting = {...setting, 
                    geniusOne: item.rules.genius.genius_one,
                    geniusTwo: item.rules.genius.genius_two,
                    geniusThree: item.rules.genius.genius_three
                  }
                }

                this.settings.push(setting)
              });

              this.loading = false
          })
          .catch(this.$root.handleRequestError);
      }
    },
    getDestinationsOpts() {
      this.$root.api.get('/zoned-areas/master?withZones=true')
        .then(res => {
            this.destinationsOpts = res.data
        })
        .catch(this.$root.handleRequestError)
        .then(() => {
            this.loading = false;
        });
    },
    getSalesChannelsOpts() {
      this.$root.api.get('/sales-channels?limit=2000')
        .then(res => {
            this.salesChannelsOpts = res.data.rows.map(zn => ({id: zn.id, name: zn.name}))
        })
        .catch(this.$root.handleRequestError)
        .then(() => {
            this.loading = false;
        });
    },
    submit(event) {
      event.preventDefault();

      let rParams = {
        url: this.modelId > 0 ? `/sales-channel-rules/${this.modelId}` : "/sales-channel-rules",
        method: this.modelId > 0 ? "put" : "post"
      };

      this.model.settings = this.settings

      if (rParams.method == "get") {
        rParams["params"] = this.model
      } else {
        rParams["data"] = this.model
      }

      api(this).request(rParams).then((res) => {
        if (res.status == 200 || res.status == 201) {
          if (res.data.error) {
            this.$root.showAlert(res.data.error, {
              variant: "warning"
            });
            return false;
          }

          this.$root.showAlert("OK!");
          if (res.data.id) this.loadModel(res.data.id, res.data.ruleType);
          this.successCallback(res);
        }

        this.loading = false;
        }).catch(this.$root.handleRequestError).then(() => {
					this.loading = false;
				});
    },
    addRuleSetting() {
      // validate required params
      try {
        if (this.$root.isEmpty(this.model.name)) throw new Error("Indique un nombre para la regla de canal")
				if (this.$root.isEmpty(this.model.zones)) throw new Error("Seleccione una zona");
        if (this.model.ruleType == 'buffer_time' && this.$root.isEmpty(this.setting.bufferTimeNational)) throw new Error("Indique buffer time para vuelos nacionales");
        if (this.model.ruleType == 'buffer_time' && this.$root.isEmpty(this.setting.bufferTimeInternational)) throw new Error("Indique buffer time para vuelos internacionales");
        if (this.model.ruleType == 'buffer_time' && this.$root.isEmpty(this.setting.bufferTimeUnit)) throw new Error("Indique unidad de tiempo para buffer time");

        if (this.model.ruleType == 'genius_booking') {
          if (this.$root.isEmpty(this.setting.geniusOne)) {
            throw new Error("Valor incorreto para Genius 1 (min. 5, max. 10)")
          }

          if (this.$root.isEmpty(this.setting.geniusTwo)) {
            throw new Error("Valor incorreto para Genius 2 (min. 5, max. 10)")
          }

          if (this.$root.isEmpty(this.setting.geniusThree)) {
            throw new Error("Valor incorreto para Genius 3 (min. 5, max. 10)")
          }

          if (this.setting.geniusOne != 0 && this.setting.geniusOne < 5 
            || this.setting.geniusOne != 0 && this.setting.geniusOne > 10) {
            throw new Error("Valor incorreto para Genius 1 (min. 5, max. 10)")
          }

          if (this.setting.geniusTwo != 0 && this.setting.geniusTwo < 5 
            || this.setting.geniusTwo != 0 && this.setting.geniusTwo > 10) {
            throw new Error("Valor incorreto para Genius 2 (min. 5, max. 10)")
          }

          if (this.setting.geniusThree != 0 && this.setting.geniusThree < 5 
            || this.setting.geniusThree != 0 && this.setting.geniusThree > 10) {
            throw new Error("Valor incorreto para Genius 3 (min. 5, max. 10)")
          }
        }
			
      } catch(err) {
				this.$root.showAlert(err.message, {variant:'info'})
				return;
			}

      let item = {...this.setting }
      try {
				
        // validate repeated rule settings
				let getArrayForComparation = function(item, invertZones = false) {
					if (invertZones) {
						return [item.type, item.serviceTypeCategoryId, item.toZoneId.id, item.fromZoneId.id]
					} else {
						return [item.type, item.serviceTypeCategoryId, item.fromZoneId.id, item.toZoneId.id]
					}
				}

				this.settings.forEach((_item) => {
					let itemToPushArr = getArrayForComparation(item);
					let itemArr       = getArrayForComparation(_item);
					if (itemToPushArr.join() == itemArr.join()) throw "repeated";
					if (_item.applyReturn) {
            //si el item actual del recorrido tiene la opcion de que aplica retorno
						let itemToPushArr = getArrayForComparation(item);
            //invertimos las zonas para la comparacion
						let itemArr       = getArrayForComparation(_item,true);
						if(itemToPushArr.join() == itemArr.join()) throw "repeated";
					}
					if (item.applyReturn) {
            //si el item a agregar tiene la opcion de que aplica retorno
						let itemToPushArr = getArrayForComparation(item,true);//invertimos las zonas para la comparacion
						let itemArr       = getArrayForComparation(_item);
						if(itemToPushArr.join() == itemArr.join()) throw "repeated";
					}
				})
			} catch(err) {
				this.$root.showAlert("Ya se existe una regla de canal similar",{variant:'info'});
				return;
			}

      this.settings.push(item)
    },
    getServiceTypeCategories() {
      this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesCategories']})
    },
    getServiceTypeName(value) {
      let category = this.$root.auxVars.serviceTypesCategoriesOpts.filter(st => st.value == value)
      if (category.length > 0) {
        return category[0].name
      }

      if (value == 0 || value == null) {
        return "Todos los servicios"
      }
    },
    getTicketTypeName(value) {
      if (value == '' || value == null) {
        return "Todos"
      }

      return value
    },
    getTimeUnitName(value) {
      let result = this.timeOpts.filter(tu => tu.value == value)
      if (result.length > 0) {
        return result[0].text
      }
    },
    confirmDelete(index) {
			this.$bvModal.msgBoxConfirm('¿Esta seguro que desea eliminar esta configuración?', {
				title: 'Confirmación eliminación',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'SI, Eliminar!',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false
			})
			.then(value => {
				if(value) this.settings.splice(index, 1);
			})
			.catch(err => {
				console.log(err)
			})
		},
    resetZonesValues() {
      this.setting.fromZoneId = null
      this.setting.toZoneId   = null
    },
  },
  computed: {
    zonesOpts() {
      if (this.model.zones != null) {
        let optDefault = [{id:0, name: "Todos las zonas"}];
        let zonesOpts  = this.model.zones.zones.map(zn => ({id: zn.id, name: zn.name}))
        return [...optDefault, ...zonesOpts]
      }

      return []
    },

    serviceTypeOpts(){
			let optDefault = [{value:0,text:"Todos los servicios"}];
      let categories = this.$root.auxVars.serviceTypesCategoriesOpts.filter(st => st.value != 1)
      return [ ...optDefault, ...categories]
		},
    ruleName() {
      if (this.model.ruleType == 'buffer_time') {
        return "Buffer Time"
      }
      if (this.model.ruleType == 'cutoff') {
        return "Cutoff"
      }

      return ""
    },
    disabled() {
      if (this.modelId > 0) return true
      return false
    },
    getTableColumns() {
      if (this.model.ruleType == 'buffer_time') {
        return [
          { key: "index",                   label: "#" },
          { key: "serviceTypeId",           label: "Service type" },
          { key: "fromZoneId.name",         label: "Zona pickup" },
          { key: "toZoneId.name",           label: "Zona dropoff" },
          { key: "type",                    label: "Ticket" },
          { key: 'bufferTimeNational',      label: 'Buffer time nac.'},
          { key: 'bufferTimeInternational', label: 'Buffer time int.'},
          { key: 'bufferTimeUnit',          label: 'Buffer time uni.'},
          { key: 'applyReturn',             label: 'Aplicar inversa'},
          { key: "actions",                 label: "acciones" }
        ]
      }

      if (this.model.ruleType == 'cutoff') {
        return [
          { key: "index",                   label: "#" },
          { key: "serviceTypeId",           label: "Service type" },
          { key: "fromZoneId.name",         label: "Zona pickup" },
          { key: "toZoneId.name",           label: "Zona dropoff" },
          { key: "type",                    label: "Ticket" },
          { key: 'cutoffTime',              label: 'Cutoff time'},
          { key: 'cutoffTimeUnit',          label: 'Cutoff time uni.'},
          { key: 'applyReturn',             label: 'Aplicar inversa'},
          { key: "actions",                 label: "acciones" }
        ]
      }

      if (this.model.ruleType == 'genius_booking') {
        return [
          { key: "index",                   label: "#" },
          { key: "serviceTypeId",           label: "Service type" },
          { key: "fromZoneId.name",         label: "Zona pickup" },
          { key: "toZoneId.name",           label: "Zona dropoff" },
          { key: "type",                    label: "Ticket" },
          { key: "geniusOne",               label: "Nivel 1" },
          { key: "geniusTwo",               label: "Nivel 2" },
          { key: "geniusThree",             label: "Nivel 3" },
          { key: 'applyReturn',             label: 'Aplicar inversa'},
          { key: "actions",                 label: "acciones" }
        ]
      }

      return []
    }
  },
  mounted() {
    this.getSalesChannelsOpts()
    this.getDestinationsOpts()
    this.getServiceTypeCategories()
  }
}

</script>